// useFeatureGate — React hook for checking feature entitlements.
// Returns whether a feature is enabled based on the current account tier.

import { useSelector } from "react-redux";
import {
  selectEntitlement,
  checkFeatureGate,
} from "../store/slices/entitlementSlice.ts";

type Feature = "overlays" | "schemaNavigation" | "multiContext" | "multiScenario";

/**
 * Check if a feature is available for the current entitlement tier.
 * When no entitlement is loaded (null), defaults to free-tier behavior:
 * all features are available (ungated) to avoid blocking first-time users.
 */
export function useFeatureGate(feature: Feature): boolean {
  const entitlement = useSelector(selectEntitlement);
  // When no entitlement is loaded, allow everything (development/demo mode)
  if (!entitlement) return true;
  return checkFeatureGate(entitlement, feature);
}
